import React from 'react'
import CardItem from './CardItem'
import './About.css'

function About() {
  return (
    <div className='cards' id="cards-section">
        <h1>Wolves Vs Sheep Simulation</h1>
        <p>I'm Aidan, a dedicated student in the Software Engineering Co-op program at the University of Guelph. I'm passionate about expanding my knowledge of coding and 
            emerging technologies. With an eye towards leveraging technology to streamline processes and enhance accessibility, I'm enthusiastic about making a positive impact 
            through my work.</p>
        
    </div>
  )
}

export default About